"use client";


import {getProductConfData} from "../../../provider/magento/api/products";
import apiFetcher from "../../../provider/magento/apiFetcher";
import {normalizeProductConfData} from "../../../provider/magento/normalizers/confdata";
import {useFrontendConfiguratorContext} from "../ProductConfigurator/context";
import {usePhrase} from "../../i18n";
import {useSearchParams} from "next/navigation";
import {useEffect, useState} from "react";
import Field from "./Input/Field";
import DropDown from "./Input/DropDown";
import Number from "./Input/Number";
import MeasuresBox from "./Input/MeasuresBox";
import {Loader} from "../Loader/Loader";
import {roundPrice} from "../../utilities/price";

const confLog = (...args) => {
    if (process.env.NEXT_PUBLIC_ENABLE_DEBUG !== 'true') {
        return;
    }
    console.log('LOG DEBUG CONF:', ...args);
}
const confPriceLog = (...args) => {
    if (process.env.NEXT_PUBLIC_ENABLE_DEBUG !== 'true') {
        return;
    }
    console.log('LOG PRICE CONF:', ...args);
}

const normalizeSku = (sku) => {
    return sku.replace(/[^a-zA-Z0-9]/g, '_');
}
const FutureProductConfigurator = ({currency, product, showErrors, storeCode, _t}) => {


    const {
        setup,
        loadState,
        currentConfiguration,
        setCurrentConfigurationOption,
        setCurrentConfigurationActions,
        setCurrentConfigurationVariables,
        setCurrentConfigurationPrice,
        setCurrentConfigurationPriceFormulaPrice,
        setCurrentConfigurationFinalPrice,
        setCurrentConfigurationFinalPriceGrandTotal,
        setErrors,
        errors,
        loadOptionsPresets,
        setItemId
    } = useFrontendConfiguratorContext();

    const t = usePhrase(_t);

    const query = useSearchParams();
    const itemId = query.get('itemId') || null;
    //const [showErrors, setShowErrors] = useState(showErrors);


    // const {data: productConfData} = useSWRImmutable(getProductConfData(product.id, itemId, storeCode), (...args) => apiFetcher(...args).then(res => normalizeProductConfData(res)));

    const [productConfData, setProductConfData] = useState(null);


    useEffect(() => {

        apiFetcher(...getProductConfData(product.id, itemId ?? null, storeCode)).then(res => {
            setProductConfData(normalizeProductConfData(res));
        });
    }, []);

    const handleSetConfOption = (e) => {
        const optionId = e.name;
        const optionValue = e.value;
        confLog('SET OPTION', optionId, optionValue);
        //console.log('SET OPTION', optionId, optionValue);
        setCurrentConfigurationOption(optionId, optionValue);
    }


    const parseTextVars = (text = '') => {
        let matches = text.match(/\$(VAR|OPT|PROD)\.([a-zA-Z0-9\-_]+)/g);
        if (matches) {
            matches.map(v => {
                let varName = v.match(/\$(VAR|OPT|PROD)\.([a-zA-Z0-9\-_]+)/);
                let varType = varName[1];
                let varProp = varName[2];
                let obj = null;
                let value = 0;
                if (varType === "VAR") {
                    obj = currentConfiguration.variables.find(v => v.code.toUpperCase() === varProp.toUpperCase());
                    if (obj && obj.value && !isNaN(parseFloat(obj.value)))
                        value = obj.value;
                    else if (obj && obj.default_value && !isNaN(parseFloat(obj.default_value)))
                        value = obj.default_value;
                } else if (varType === "OPT") {
                    obj = currentConfiguration.options.find(o => o.sku.toUpperCase() === varProp.toUpperCase());
                    if (obj && obj.value) {
                        if (obj?.value?.option_type_id) {
                            value = obj.value.sku;
                        } else {
                            value = (!isNaN(parseFloat(obj.value))) ? obj.value : obj.value;
                        }
                    }
                } else if (varType === "PROD") {
                    obj = setup.product;
                    if (obj && !isNaN(parseFloat(obj[varProp]))) {
                        value = parseFloat(obj[varProp]).toFixed(2);
                    }
                }
                text = text.replace(v, value || 0);
            });
        }
        return text;
    }

    const parseFormula = (formula = '') => {

        confLog('Parse formula ' + formula);

        if (!formula || !formula.trim().match(/^=/)) {
            return formula;
        }

        let currentDefaultValue = formula.replace(/^=/, '');

        let matches = currentDefaultValue.match(/\$(VAR|OPT|PROD)\.([a-zA-Z0-9\-_]+)/g);

        matches.map(v => {

            confLog('Match ' + v);

            let varName = v.match(/\$(VAR|OPT|PROD)\.([a-zA-Z0-9\-_]+)/);

            let varType = varName[1];
            let varProp = varName[2];

            let obj = null;

            let value = 0;

            if (varType === "VAR") {
                obj = currentConfiguration.variables.find(v => v.code.toUpperCase() === varProp.toUpperCase());
                if (obj && obj.value && !isNaN(parseFloat(obj.value)))
                    value = parseFloat(obj.value);
                else if (obj && obj.default_value && !isNaN(parseFloat(obj.default_value)))
                    value = parseFloat(obj.default_value);
            } else if (varType === "OPT") {
                obj = currentConfiguration.options.find(o => o.sku.toUpperCase() === varProp.toUpperCase());
                if (obj && obj.value) {
                    if (obj?.value?.option_type_id) {
                        value = obj.value.sku;
                    } else {
                        value = (!isNaN(parseFloat(obj.value))) ? parseFloat(obj.value) : obj.value;
                    }
                }
            } else if (varType === "PROD") {
                obj = setup.product;
                if (obj && !isNaN(parseFloat(obj[varProp]))) {
                    value = parseFloat(obj[varProp]).toFixed(2);
                }
            }

            currentDefaultValue = currentDefaultValue.replace(v, value || 0);

        });

        let funcsMax = currentDefaultValue.match(/MAX\([0-9\.]+,[0-9\.]+\)/gi);
        if (funcsMax) {
            funcsMax.map(funcMax => {
                confLog('Func max ' + funcMax);
                let values = funcMax.match(/MAX\(([0-9\.]+),([0-9\.]+)\)/i);
                currentDefaultValue = currentDefaultValue.replace(funcMax, Math.max(parseFloat(values[1]), parseFloat(values[2])));
            });
        }

        let funcsMin = currentDefaultValue.match(/MIN\([0-9\.]+,[0-9\.]+\)/gi);
        if (funcsMin) {
            funcsMin.map(funcMin => {
                confLog('Func min ' + funcMin);
                let values = funcMin.match(/MIN\(([0-9\.]+),([0-9\.]+)\)/i);
                currentDefaultValue = currentDefaultValue.replace(funcMin, Math.min(parseFloat(values[1]), parseFloat(values[2])));
            });
        }

        return currentDefaultValue;

    }

    const checkRules = () => {
        // check rules

        confLog('CHECK RULES');

        if (!setup.rules) return;

        let actionsToApply = [];

        for (let ruleIndex = 0; ruleIndex < setup.rules.length; ruleIndex++) {

            let rule = setup.rules[ruleIndex];

            let ruleIsValid = false;

            for (let conditionIndex = 0; conditionIndex < rule.conditions.length; conditionIndex++) {

                let condition = rule.conditions[conditionIndex];

                let currentOption = null;
                if (condition.option) {
                    currentOption = currentConfiguration.options.find(o => o.option_id === condition.option);
                    if (!currentOption) continue;
                }

                //confLog(condition, currentOption);

                if (!condition.optionValue || condition.variable_id) {


                    let conditionValue = condition?.value ? condition.value.trim() : '';


                    if (conditionValue.match(new RegExp(/^=/))) {

                        conditionValue = parseFormula(conditionValue);

                        confLog('conditionValue', conditionValue);

                        let conditionParsed = conditionValue.match(/^([0-9.*-+/\(\)]+)$/);

                        if (conditionParsed) {
                            try {
                                conditionValue = new Function(`return ${conditionParsed[1]}`)();
                            } catch (e) {
                                console.error('error parsing condition value');
                                conditionValue = 0;
                            }
                        }

                    }


                    conditionValue = ((currentOption && currentOption.type === 'number') || condition.variable_id) ? parseFloat(conditionValue) : conditionValue;

                    let currentOptionValue = null;

                    if (condition.variable_id) {
                        let variable = currentConfiguration.variables.find(v => parseInt(v.variable_id) === parseInt(condition.variable_id));
                        currentOptionValue = variable ? parseFloat(variable.value) : null;
                        confLog('CONDITION VARIABLE', condition, variable);

                    } else if (currentOption) {
                        currentOptionValue = currentOption.type === 'number' ? parseFloat(currentOption.value) : (currentOption?.value?.option_type_id ? currentOption.value.sku : currentOption.value);

                        confLog('CONDITION OPTION', condition);

                    } else {
                        confLog('CONDITION OPTION NOT FOUND', condition);
                        continue;
                    }
                    confLog('RULE', condition?.option ?? condition?.variable_id, currentOptionValue, condition.operator, conditionValue);


                    switch (condition.operator) {
                        case '=':
                            if (currentOptionValue === conditionValue)
                                ruleIsValid = true;
                            else
                                ruleIsValid = false;

                            break;
                        case '!=':
                            if (currentOptionValue !== conditionValue)
                                ruleIsValid = true;
                            else
                                ruleIsValid = false;

                            break;
                        case 'in':
                            if (conditionValue && conditionValue.indexOf(currentOptionValue) !== -1)
                                ruleIsValid = true;
                            else
                                ruleIsValid = false;

                            break;
                        case 'not in':
                            if (conditionValue && conditionValue.indexOf(currentOptionValue) === -1)
                                ruleIsValid = true;
                            else
                                ruleIsValid = false;

                            break;
                        case '>':
                            if (currentOptionValue > conditionValue)
                                ruleIsValid = true;
                            else
                                ruleIsValid = false;

                            break;
                        case '<':
                            if (currentOptionValue < conditionValue)
                                ruleIsValid = true;
                            else
                                ruleIsValid = false;

                            break;
                        case '>=':
                            if (currentOptionValue >= conditionValue)
                                ruleIsValid = true;
                            else
                                ruleIsValid = false;

                            break;
                        case '<=':
                            if (currentOptionValue <= conditionValue)
                                ruleIsValid = true;
                            else
                                ruleIsValid = false;

                            break;
                        case 'like':
                            if (currentOptionValue && currentOptionValue.match(conditionValue))
                                ruleIsValid = true;
                            else
                                ruleIsValid = false;

                            break;
                        case 'notlike':
                            if (!currentOptionValue || !currentOptionValue.match(conditionValue))
                                ruleIsValid = true;
                            else
                                ruleIsValid = false;

                            break;
                    }

                    if (!ruleIsValid) break;

                    confLog('RULE VALID', ruleIsValid);


                } else if (currentOption) {

                    let currentOptionValue = currentOption.value ? currentOption.value.option_type_id : null;

                    if (condition.operator === 'selected') {
                        if (currentOptionValue === condition.optionValue)
                            ruleIsValid = true;
                        else
                            ruleIsValid = false;

                    } else if (condition.operator === 'notselected') {
                        if (currentOptionValue !== condition.optionValue)
                            ruleIsValid = true;
                        else
                            ruleIsValid = false;

                    } else {
                        ruleIsValid = false;
                    }

                    if (!ruleIsValid) break;
                } else {
                    confLog('RULE NOT VALID');
                }

            }

            //confLog(ruleIsValid);

            if (ruleIsValid)
                actionsToApply.push(...rule.actions);

        }

        setCurrentConfigurationActions(actionsToApply);
    }

    const checkVariables = () => {

        confLog('CHECK VARIABLES');

        if (!setup.variables) return;

        let curVariables = [];

        setup.variables.map(variable => {
            if (variable.required) {

                confLog('[VAR] check required ' + variable.code);

                if ((!variable.value || variable.default_value.match(/^=/)) && variable?.default_value) {

                    confLog('[VAR] check default value ' + variable.code + ' ' + variable.default_value);

                    let currentDefaultValue = variable.default_value;

                    if (variable.default_value.match(/^=/)) {
                        currentDefaultValue = parseFormula(variable.default_value);
                    }

                    curVariables.push({...variable, ...{value: currentDefaultValue}});
                } else {
                    curVariables.push(variable);
                }
            }
        });

        currentConfiguration.options.sort((a, b) => a.sort_order - b.sort_order).map(curOptionValue => {

            if (curOptionValue.value && curOptionValue.value.variables) {
                curOptionValue.value.variables.map(variable => {
                    //setCurrentConfigurationVariable(key, value);

                    let rootVariable = setup.variables.find(v => v.variable_id === variable.variable_id);

                    let curVarIndex = curVariables.findIndex(v => v.variable_id === variable.variable_id);

                    if (curVarIndex !== -1) {

                        if (rootVariable.method === 'higher')
                            curVariables[curVarIndex] = curVariables[curVarIndex].value > variable.value ? curVariables[curVarIndex] : variable;
                        else if (rootVariable.method === 'lower')
                            curVariables[curVarIndex] = curVariables[curVarIndex].value < variable.value ? curVariables[curVarIndex] : variable;
                        else if (rootVariable.method === 'order')
                            curVariables[curVarIndex] = variable;
                    } else {
                        curVariables.push(variable);
                    }
                });
            }


        });

        confLog(curVariables);

        setCurrentConfigurationVariables(curVariables);


    }

    const checkErrors = () => {
        confLog('CHECK REQUIRED OPTIONS');

        let newErrors = [];

        setup.options.map(option => {

            if (option.is_require == '1') {

                let currentOption = currentConfiguration.options.find(o => o.option_id === option.option_id);

                if (!currentOption) {

                    newErrors.push({
                        option_id: option.option_id,
                        message: t('Field is required')//'Il campo ' + option.title + ' è obbligatorio'
                    });


                }

            }


        });

        currentConfiguration.actions.filter(a => a.action === 'error').map(a => {
            newErrors.push({
                option_id: a.option,
                message: parseTextVars(a.value)
            });
        });

        setErrors(newErrors);

    }


    const getPriceFormulaPrice = (basePrice = 0) => {

        confLog('CHECK PRICE FORMULA');


        confLog('Price Formula: ' + setup.priceFormula);

        let formulaParsed = setup.priceFormula.match(/^=IF\(([^;]+);([^;]+);(.+)\)$/);

        if (!formulaParsed) {
            console.error(`INVALID PRICE FORMULA`);
            return;
        }


        let condition = formulaParsed[1];
        let trueValue = formulaParsed[2];
        let falseValue = formulaParsed[3];


        [condition, trueValue, falseValue] = [condition, trueValue, falseValue].map(lemma => {
            let vars = lemma.match(/\$(VAR|OPT|PROD|CUR)\.([a-zA-Z0-9\-_]+)/g);
            if (vars) {

                vars = vars.sort((v1, v2) => v2.length - v1.length).map(v => {

                    let varName = v.match(/\$(VAR|OPT|PROD|CUR)\.([a-zA-Z0-9\-_]+)/);

                    let varType = varName[1];
                    let varProp = varName[2];

                    let obj = null;

                    let value = 0;

                    if (varType === "VAR") {
                        obj = currentConfiguration.variables.find(v => v.code.toUpperCase() === varProp.toUpperCase());
                        if (obj && obj.value && !isNaN(parseFloat(obj.value)))
                            value = parseFloat(obj.value);
                        else if (obj && obj.default_value && !isNaN(parseFloat(obj.default_value)))
                            value = parseFloat(obj.default_value);
                    } else if (varType === "OPT") {
                        obj = currentConfiguration.options.find(o => o.sku.toUpperCase() === varProp.toUpperCase());
                        if (obj && obj.value) {
                            if (obj?.value?.option_type_id) {
                                value = '"'+obj.value.sku+'"';
                            } else {
                                value = (!isNaN(parseFloat(obj.value))) ? parseFloat(obj.value) : obj.value;
                            }
                        }
                    } else if (varType === "PROD") {
                        obj = setup.product;
                        if (obj && !isNaN(parseFloat(obj[varProp]))) {
                            value = parseFloat(obj[varProp]).toFixed(2);
                        }
                    } else if (varType === "CUR") {
                        if (varProp === 'price') {
                            value = parseFloat(basePrice).toFixed(2);
                        }
                    }

                    lemma = lemma.replace(v, value || 0);

                });
            }

            let funcsMax = lemma.match(/MAX\([0-9\.]+,[0-9\.]+\)/gi);
            if (funcsMax) {
                funcsMax.map(funcMax => {
                    confLog('func max ' + funcMax);
                    let values = funcMax.match(/MAX\(([0-9\.]+),([0-9\.]+)\)/i);
                    lemma = lemma.replace(funcMax, Math.max(parseFloat(values[1]), parseFloat(values[2])));
                });
            }


            return lemma;

        });

        confPriceLog(`CONDITION: ${condition}`);
        confPriceLog(`TRUE: ${trueValue}`);
        confPriceLog(`FALSE: ${falseValue}`);

        let conditionParsed = condition.match(/^([a-zA-Z"0-9.*-+/\(\)]+)(<|>|==|>=|<=|!=)([a-zA-Z"0-9.*-+/\(\)]+)$/);
        let trueValueParsed = trueValue.match(/^([0-9.*-+/\(\)]+)$/);
        let falseValueParsed = falseValue.match(/^([0-9.*-+/\(\)]+)$/);


        if (conditionParsed === null || trueValueParsed === null || falseValueParsed === null) return;


        let finalPrice;

        if (new Function('return ' + conditionParsed[1] + ' ' + conditionParsed[2] + ' ' + conditionParsed[3])()) {

            confPriceLog(`CONDITION MATCH! EXE FORMULA: ${trueValueParsed[1]}`);
            finalPrice = new Function('return ' + trueValueParsed[1])();
        } else {
            confPriceLog(`CONDITION NOT MATCH! EXE FORMULA: ${falseValueParsed[1]}`);

            finalPrice = new Function('return ' + falseValueParsed[1])();
        }

        confPriceLog(`FORMULA PRICE: ${finalPrice}`);


        return roundPrice(finalPrice);

    }

    const calcBasePrice = () => {

        /// get product base price

        if (!setup.product) return;

        const basePrice = setup.product.price || 0;

        confPriceLog(`PRODUCT BASE PRICE: ${basePrice}`);

        let newBasePrice = basePrice;

        // get options can edit base price

        // if in currentConfiguration.options there is options with sku like HEIGHT,WIDTH,HEIGHT_2,WIDTH_2
        if (setup.options && setup.options.filter(o => ['HEIGHT', 'HEIGHT_2', 'WIDTH', 'WIDTH_2'].includes(o.sku)).length === 4) {

            if (currentConfiguration.options.filter(o => ['HEIGHT', 'HEIGHT_2', 'WIDTH', 'WIDTH_2'].includes(o.sku)).length === 4) {

                currentConfiguration.options.sort((a, b) => parseInt(a.price_order) - parseInt(b.price_order)).map(option => {

                    let curSubj = option;

                    if (option.value && option.value.option_type_id)
                        curSubj = option.value;

                    if (curSubj.price_target && curSubj.price_target !== 'base') return;

                    let addPrice = roundPrice(curSubj.price_type === 'fixed' ? parseFloat(curSubj.price) : (parseFloat(newBasePrice) * (parseFloat(curSubj.price)) / 100));

                    confPriceLog(`(BASE) OPTION [${option.title}] ${curSubj.title} (${curSubj.price_target ?? '!!'} - ${option.price_order}) ADD PRICE ${addPrice}`);
                    newBasePrice += addPrice;

                });
            }
        }

        setCurrentConfigurationPrice(newBasePrice);
        // return base price


        return newBasePrice;

    }


    const applyPromoRule = (price) => {
        if (setup.product.promo && setup.product.promo > 0) {
            //confPriceLog(`PROMO FINAL PRICE ( NO ROUND) ${price - (price * (setup.product.promo / 100))}`);
            price = roundPrice(parseFloat(price - (price * (setup.product.promo / 100))));
            //confPriceLog(`PROMO FINAL PRICE ${price}`);
        }
        return price;
    }

    const calcFinalPrice = () => {

        if (!setup.product) return;

        const basePrice = roundPrice(parseFloat(calcBasePrice()));

        confPriceLog(`CONF BASE PRICE: ${basePrice}`);

        let price = basePrice;

        // if in currentConfiguration.options there is options with sku like HEIGHT,WIDTH,HEIGHT_2,WIDTH_2
        if (setup.options && setup.options.filter(o => ['HEIGHT', 'HEIGHT_2', 'WIDTH', 'WIDTH_2'].includes(o.sku)).length === 4) {

            if (currentConfiguration.options.filter(o => ['HEIGHT', 'HEIGHT_2', 'WIDTH', 'WIDTH_2'].includes(o.sku)).length === 4) {


                if (setup.priceFormula && setup.priceFormula.length > 0) {
                    price = getPriceFormulaPrice(basePrice);
                    setCurrentConfigurationPriceFormulaPrice(price);

                }


                confPriceLog(`PRICE FORMULA PRICE: ${price}`);


                currentConfiguration.options.sort((a, b) => parseInt(a.price_order) - parseInt(b.price_order)).map(option => {
                    let curSubj = option;

                    if (option.value && option.value.option_type_id)
                        curSubj = option.value;

                    if (!curSubj.price_target || curSubj.price_target !== 'final') return;

                    let addPrice = roundPrice(curSubj.price_type === 'fixed' ? parseFloat(curSubj.price) : parseFloat(price) * (parseFloat(curSubj.price) / 100));

                    price += addPrice;

                    confPriceLog(`(FINAL) OPTION [${option.title}] ${curSubj.title} (${curSubj.price_target ?? '!!'} - ${option.price_order}) ADD PRICE ${addPrice}`);
                });


            }

        }


        confPriceLog(`FINAL PRICE ${price}`);

        setCurrentConfigurationFinalPrice(roundPrice(parseFloat(price)));

        const roundPromo = (promoPrice) => {
            return (parseFloat(promoPrice).toFixed(4) * 100) / 100;
        }


            //console.log('PROMO RULES', setup.product);

            if (setup.product.rules && setup.product.rules.length > 0) {
                setup.product.rules.map(p => {
                    confPriceLog(`PROMO ${p}% -- FROM ${price}`);

                    price = roundPrice(price - price * (p / 100));

                    confPriceLog(`PROMO ${p}% -- TO ${price}`);

                });
            }




        if (setup.product.tax && setup.product.tax > 0) {
            confPriceLog(`TAX FINAL PRICE (NO ROUND) ${price + (price * (roundPrice(setup.product.tax) / 100))}`);
            price = roundPrice(parseFloat(price + (price * (roundPrice(setup.product.tax) / 100))));
            confPriceLog(`TAX FINAL PRICE ${price}`);
        }

        setCurrentConfigurationFinalPriceGrandTotal(roundPrice(parseFloat(price)));

    }


    const renderOptions = () => {

        if (!setup.options) return <></>;

        let optsOut = {};

        let heightOpt = setup.options.find(o => o.sku === 'HEIGHT' && o.is_visible=="1" && o.is_active=="1");
        let height2Opt = setup.options.find(o => o.sku === 'HEIGHT_2' && o.is_visible=="1" && o.is_active=="1");
        let widthOpt = setup.options.find(o => o.sku === 'WIDTH' && o.is_visible=="1" && o.is_active=="1");
        let width2Opt = setup.options.find(o => o.sku === 'WIDTH_2' && o.is_visible=="1" && o.is_active=="1");

        //console.log(heightOpt, height2Opt, widthOpt, width2Opt);


        let optionsToExclude = [];
        [heightOpt,height2Opt,widthOpt,width2Opt].map(opt => {
           if(opt){
               optionsToExclude.push(opt.sku);
           }
        });

        setup.options.filter(o => !optionsToExclude.includes(o.sku)).sort((a, b) => a.sort_order - b.sort_order).map((option, optionIndex) => {


            //if(option.is_visible === '0') return null;

            if (option.type === 'drop_down' && option.is_require == "1" && option.values.length === 1) {
                return null;
            }

            let currentValue = currentConfiguration?.options.find(opt => opt.option_id === option.option_id)?.value;

            optsOut[option.sort_order] = (
                <div key={['conf', 'option', option.option_id].join('_')} className={'mb-1.5'}>
                    {option.type === 'field' && <Field key={`field_${option.option_id}`}
                                                       id={`field_option_${normalizeSku(option.sku)}`}
                                                       name={option.option_id}
                                                       option={option}
                                                       value={currentValue}
                                                       currency={currency}
                                                       priceUnit={product?.price_unit}
                                                       onChange={handleSetConfOption}/>}
                    {option.type === 'number' && <Number key={`field_${option.option_id}`}
                                                         id={`field_option_${normalizeSku(option.sku)}`}
                                                         prefix={'mm'}
                                                         suffix={'mm'}
                                                         name={option.option_id}
                                                         option={option}
                                                         value={currentValue}
                                                         currency={currency}
                                                         priceUnit={product?.price_unit}
                                                         onChange={handleSetConfOption}/>}
                    {option.type === 'drop_down' && <DropDown key={`field_${option.option_id}`}
                                                              id={`btn_option_${normalizeSku(option.sku)}`}
                                                              name={option.option_id}
                                                              option={option}
                                                              placeholder={t(`Select an option..`)}
                                                              value={currentValue}
                                                              currency={currency}
                                                              itemId={itemId}
                                                              priceUnit={product?.price_unit}
                                                              onChange={handleSetConfOption}
                                                              _t={_t}/>}

                    {showErrors && currentConfiguration?.errors && currentConfiguration?.errors.filter(e => e.option_id === option.option_id).map((error, errorIndex) => {
                        return <p key={['conf', 'option', option.option_id, 'error', errorIndex].join('_')}
                                  className={'text-red-500 text-xs'}>{error.message}</p>
                    })}
                </div>);

        });

        if (heightOpt || widthOpt || height2Opt || width2Opt) {
            optsOut[Math.min(...[heightOpt, height2Opt, widthOpt, width2Opt].filter(o => !!o).map(o => o.sort_order))] = (
                <MeasuresBox key={`conf_measures_box_h_w_${product.id}`} currentConfiguration={currentConfiguration}
                             heightOpt={heightOpt} height2Opt={height2Opt} widthOpt={widthOpt} width2Opt={width2Opt}
                             currency={currency} showErrors={showErrors} _t={_t}
                             onChange={handleSetConfOption}/>);
        }

        return Object.keys(optsOut).sort((a, b) => a - b).map(k => optsOut[k]);

    }

    // INITIALIZE DATA
    useEffect(() => {
        if (productConfData && productConfData.length > 0) {
            loadState(productConfData[0]);
        }
    }, [productConfData]);

    // CALCULATE START OPTIONS
    useEffect(() => {
        confLog('CALCULATE START OPTIONS');
        if (setup?.options && setup?.optsPreset && setup.optsPreset.length > 0) {
            confLog('CALCULATE START OPTIONS FROM PRESET');
            confLog(setup.optsPreset);
            loadOptionsPresets(setup.optsPreset);
        } else {
            if (setup?.options && setup.options.length > 0) {
                confLog('CALCULATE START OPTIONS FROM DEFAULT');
                confLog(setup?.options);
                setup.options.map(option => {
                    // @TODO HARDCODING COL OPTION
                    if (option.is_require !== '1' || option.sku === 'COL') return;
                    if (option.type === 'drop_down') {
                        if (option.values && option.values.length > 0) {
                            let sortedValues = option.values.sort((a, b) => b.is_default - a.is_default);
                            setCurrentConfigurationOption(option.option_id, sortedValues[0]);
                        }
                    }
                });
            }
        }
    }, [setup?.options]);

    useEffect(() => {
        setItemId(itemId);
    }, [itemId]);

    useEffect(() => {
        confLog('CHANGE CURRENT OPTIONS', currentConfiguration?.options);
        checkVariables();
        //checkRules();
    }, [currentConfiguration?.options]);

    useEffect(() => {
        confLog('CHECKING RULES');
        //checkVariables();
        checkRules();
    }, [currentConfiguration?.options, currentConfiguration?.variables]);


    useEffect(() => {
        checkErrors();
        calcFinalPrice();
    }, [currentConfiguration?.price, currentConfiguration?.options, currentConfiguration?.actions, currentConfiguration?.variables]);


    if (!productConfData) return <Loader/>;

    return <div id={'future-product-conf'} className={'relative'}>
        <div id={'future-product-conf-anchor'} className={'absolute lg:-top-[200px]'}></div>


        {renderOptions()}


    </div>


}

export default FutureProductConfigurator;